import { api } from "../api";

function getVisitorId() {
  let v = localStorage.getItem("ok_vid");
  if (!v) {
    v = (crypto.randomUUID ? crypto.randomUUID() : `v-${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("ok_vid", v);
  }
  return v;
}

function getSessionId() {
  const now = Date.now();
  try {
    const raw = sessionStorage.getItem("ok_sid");
    if (raw) {
      const { id, exp } = JSON.parse(raw);
      if (exp > now) {
        sessionStorage.setItem("ok_sid", JSON.stringify({ id, exp: now + 30 * 60000 }));
        return id;
      }
    }
  } catch {}
  const id = (crypto.randomUUID ? crypto.randomUUID() : `s-${Date.now()}-${Math.random().toString(36).slice(2)}`);
  sessionStorage.setItem("ok_sid", JSON.stringify({ id, exp: now + 30 * 60000 }));
  return id;
}

export function trackPage(path) {
  api.post("/analytics/track", { path, visitor_id: getVisitorId(), session_id: getSessionId() }).catch(() => {});
}
